<template>

	<div class="customer-service-page-container">
		<TopicDetailModal v-if="showTopicDetail === true" @close="onTopicDetailClose" @ticketUpdated="refreshAllTopics"
		                  :ticketItem="this.selectedItem"/>
		<AirportTicketDetailModal v-if="showAirportTicketDetail === true" @close="onAirportTicketDetailClose"
		                          @ticketUpdated="refreshAllTopics"
		                          :ticketItem="this.selectedItem"/>
		<WebsiteChatDetailModal v-if="showWebsiteChatModal" :chatItem="this.selectedItem" @close="onWebsiteChatModalClose" @msgSent="onWebsiteMsgSent"/>

		<ConfirmModal v-if="showConfirmModal===true" @cancel="onConfirmModalCancel" @confirm="onConfirmModalConfirm"
		              :confirm-msg="this.confirmMsg"/>
		<div class="cs-view-switch-container">
			<div class="cs-view-switch-wrapper">
				<div class="cs-view-switch-btn" :class="{'active': this.currentViewSwitcher === 'vpn'}"
				     @click="this.onViewSwitcherClicked('vpn')">类目一
				</div>
				<div class="cs-view-switch-btn" :class="{'active': this.currentViewSwitcher === 'airport'}"
				     @click="this.onViewSwitcherClicked('airport')">类目二
				</div>
				<div class="cs-view-switch-btn" :class="{'active': this.currentViewSwitcher === 'website'}"
				     @click="this.onViewSwitcherClicked('website')">网页
				</div>
			</div>
		</div>
		<div class="cs-search-container">
			<input class="cs-search-input" type="text" v-model="searchKeyword"
			       :placeholder="this.searchPlaceholder" @keyup.enter="onSearchClicked">
			<div class="header-btn cs-search-btn" @click="onSearchClicked">搜索</div>
			<div class="header-btn cs-search-btn" @click="onResetSearchClicked">重置</div>
		</div>
		<div class="cs-main-container" v-if="this.currentViewSwitcher === 'vpn'">
			<div class="btn-container">
				<a-pagination v-model:current="this.page" simple v-model:pageSize="this.pageSize"
				              :total="this.totalCount" @change="onVpnPageChanged"
				              :showSizeChanger="false"/>

				<div class="header-btn cs-search-btn" @click="onRefreshBtnClicked">刷新</div>
			</div>

			<div class="status-filter-container">
				<a-checkbox v-model:checked="this.statusFilter.replied" @change="onStatusFilterChanged">已回复</a-checkbox>
				<a-checkbox v-model:checked="this.statusFilter.waiting" @change="onStatusFilterChanged">未回复</a-checkbox>
				<a-checkbox v-model:checked="this.statusFilter.closed" @change="onStatusFilterChanged">已关闭</a-checkbox>
			</div>

			<div class="list-container">
				<template v-for="item in this.vpnTopicList" :key="item.feedbackTopicId">
					<div class="item-container" @click="onItemClick(item)">
						<div class="item-title-container">
							<div class="item-title">
								{{ this.formatItemTitle(item.userDescription) }}
							</div>
							<div class="item-title-actions">
								<!-- 删除是硬删（工单 + 对话 + AI 待审批回复），没有撤销，所以必须二次确认 -->
								<a-popconfirm :title="this.getDeleteConfirmText(item)"
								              ok-text="确认删除" cancel-text="取消" ok-type="danger"
								              @confirm="onDeleteTopic(item)">
									<!-- 同 Mute：卡片本身绑了打开详情，要挡冒泡 -->
									<div :class="['ticket-delete-btn',
									              this.deletingTopicId === item.feedbackTopicId ? 'is-updating' : '']"
									     @click.stop>
										Delete
									</div>
								</a-popconfirm>
								<!-- 已禁言的不再给按钮，跟用户页一致；没邮箱的工单也没法禁（禁言按邮箱走） -->
								<a-popconfirm v-if="item.email && item.isMuted !== true"
								              :title="this.getMuteConfirmText(item)"
								              ok-text="确认禁言" cancel-text="取消" @confirm="onMuteUser(item)">
									<!-- 卡片本身绑了打开详情，这里必须挡冒泡，否则点一下禁言就弹出工单详情 -->
									<div :class="['ticket-mute-btn',
									              this.mutingEmail === item.email ? 'is-updating' : '']"
									     @click.stop>
										Mute
									</div>
								</a-popconfirm>
								<div class="ticket-close-btn" v-if="item?.isClosed !== true"
								     @click="onCloseTicket(item, $event)">
									Close
								</div>
							</div>
						</div>

						<!-- 复制和状态都放邮箱这一行：客服看工单第一件事就是认人，
						     点开详情才能知道这人被封没封的话，每条工单都要多点一次 -->
						<div class="item-email item-email-line">
							<span class="item-email-text">{{ item.email }}</span>
							<img src="../images/copy_light.svg" alt="复制" class="copy-text-btn"
							     title="复制邮箱" v-if="item.email"
							     @click="onCopyText(item.email, '邮箱', $event)">
							<span :class="['user-state-tag', this.getUserStateClass(item)]"
							      :title="this.getUserStateTitle(item)">
								{{ this.getUserStateText(item) }}
							</span>
						</div>
						<!-- 列表里只露头尾各 4 位，复制的是完整 ID -->
						<div class="item-email item-email-line" v-if="item.feedbackTopicId">
							<span class="item-email-text">工单ID：{{ this.maskTicketId(item.feedbackTopicId) }}</span>
							<img src="../images/copy_light.svg" alt="复制" class="copy-text-btn"
							     title="复制工单ID"
							     @click="onCopyText(item.feedbackTopicId, '工单ID', $event)">
						</div>
						<div class="item-email" v-if="item.deviceId">
							设备ID：{{ item.deviceId }}
						</div>
						<div class="item-email">
							状态：<span :style="this.getTicketStatusStyle(item)">{{ item.topicState }}</span>
						</div>
						<div class="item-time">
							创建时间：{{ item.createdTimeString }}
						</div>
						<div class="item-time">
							更新时间：{{ item.updatedTimeString }}
						</div>
					</div>
				</template>
			</div>
		</div>

		<div class="cs-main-container" v-if="this.currentViewSwitcher === 'airport'">

			<div class="btn-container">
				<a-pagination v-model:current="this.page" simple v-model:pageSize="this.pageSize"
				              :total="this.totalCount" @change="onAirportPageChanged"
				              :showSizeChanger="false"/>

				<div class="header-btn cs-search-btn" @click="onRefreshBtnClicked">刷新</div>
			</div>

			<div class="status-filter-container">
				<a-checkbox v-model:checked="this.statusFilter.replied" @change="onStatusFilterChanged">已回复</a-checkbox>
				<a-checkbox v-model:checked="this.statusFilter.waiting" @change="onStatusFilterChanged">未回复</a-checkbox>
				<a-checkbox v-model:checked="this.statusFilter.closed" @change="onStatusFilterChanged">已关闭</a-checkbox>
			</div>


			<div class="list-container">
				<template v-for="item in this.airportTicketList" :key="item.ticketId">
					<div class="item-container" @click="onItemClick(item)">
						<div class="item-title-container">
							<div class="item-title">
								{{ this.formatItemTitle(item.subject) }}
							</div>
							<img v-if="item?.isClosed !== true" src="../images/close_topic.svg" alt="close topic"
							     @click="onCloseTicket(item, $event)">
						</div>

						<div class="item-email">
							{{ item.userEmail }}
						</div>
						<div class="item-email item-email-line" v-if="item.ticketId">
							<span class="item-email-text">工单ID：{{ this.maskTicketId(item.ticketId) }}</span>
							<img src="../images/copy_light.svg" alt="复制" class="copy-text-btn"
							     title="复制工单ID"
							     @click="onCopyText(item.ticketId, '工单ID', $event)">
						</div>
						<div class="item-email">
							状态：<span :style="this.getAirportTicketStatusStyle(item)">{{
								this.getAirportTicketStatusText(item)
							}}</span>
						</div>
						<div class="item-time">
							创建时间：{{ item.createdTimeString }}
						</div>
						<div class="item-time">
							更新时间：{{ item.updateTimeString }}
						</div>
					</div>
				</template>
			</div>

		</div>
		<div class="cs-main-container" v-if="this.currentViewSwitcher === 'website'">

			<div class="btn-container">
				<a-pagination v-model:current="this.page" simple v-model:pageSize="this.pageSize"
				              :total="this.totalCount" @change="onWebsitePageChanged"
				              :showSizeChanger="false"/>

				<div class="header-btn cs-search-btn" @click="onRefreshBtnClicked">刷新</div>
			</div>

			<div class="status-filter-container">
				<a-checkbox v-model:checked="this.statusFilter.replied" @change="onStatusFilterChanged">已回复</a-checkbox>
				<a-checkbox v-model:checked="this.statusFilter.waiting" @change="onStatusFilterChanged">未回复</a-checkbox>
				<a-checkbox v-model:checked="this.statusFilter.closed" @change="onStatusFilterChanged">已关闭</a-checkbox>
			</div>


			<div class="list-container">
				<template v-for="item in this.websiteChatList" :key="item.recordId">
					<div class="item-container" @click="onItemClick(item)">
						<div class="item-title-container">
							<div class="item-title">
								{{ item?.platformInfo?.description }}
							</div>
						</div>

						<div class="item-email">
							fp：{{item.fp}}
						</div>
						<div class="item-email">
							状态：<span :style="this.getWebsiteChatStatusStyle(item)">{{
								this.getWebsiteChatStatusText(item)
							}}</span>
						</div>
						<div class="item-time">
							创建时间：{{ item.createTimeString }}
						</div>
						<div class="item-time">
							更新时间：{{ item.updateTimeString }}
						</div>
					</div>
				</template>
			</div>

		</div>
	</div>

</template>

<script>
import {
	getRequestAsync,
	hideLoading,
	postRequestAsync,
	showLoading,
	convertTimestampToTimeString,
	verifyFp,
	copyToClipboard
} from "@/utils/methods";
import TopicDetailModal from "../components/TopicDetailModal.vue";
import AirportTicketDetailModal from "../components/AirportTicketDetailModal.vue";
import ConfirmModal from "../components/ConfirmModal.vue";
import WebsiteChatDetailModal from "../components/WebsiteChatDetailModal.vue";

export default {
	name: "CustomerServicePage",
	components: {
		TopicDetailModal,
		ConfirmModal,
		AirportTicketDetailModal,
		WebsiteChatDetailModal
	},
	data() {
		return {
			vpnTopicList: [],
			airportTicketList: [],
			websiteChatList: [],
			page: 1,
			pageSize: 20,
			totalCount: 0,
			currentViewSwitcher: 'vpn',
			searchKeyword: '',
			// 三个状态复选框，默认全勾（等于不筛选）
			statusFilter: {
				replied: true,
				waiting: true,
				closed: true
			},
			showTopicDetail: false,
			showAirportTicketDetail: false,
			showWebsiteChatModal: false,
			selectedItem: null,
			showConfirmModal: false,
			confirmMsg: '',
			confirmModalType: null,
			// 正在禁言哪个邮箱，用来防连点
			mutingEmail: null,
			// 正在删除的工单 id，用来给那一张卡片的 Delete 按钮上 loading 并防重复点击
			deletingTopicId: null
		}
	},
	computed: {
		searchPlaceholder() {
			if (this.currentViewSwitcher === 'website') {
				return '输入设备ID(fp)搜索'
			}
			if (this.currentViewSwitcher === 'airport') {
				return '输入用户邮箱 / 设备ID / 工单ID搜索'
			}
			return '输入用户邮箱或设备ID搜索'
		}
	},
	async beforeMount() {
		this.isLogin = await this.checkLogin()
		if (this.isLogin) {
			await this.getAllVpnTopics(false)
		}
	},
	methods: {
		async onRefreshBtnClicked() {
			await this.loadCurrentList(true)
		},
		/**
		 * 勾选了哪几个状态。三个都勾等于不筛选，一个都不勾就是空列表——
		 * 由服务端去判断，这里只管把勾选结果原样传过去。
		 */
		getStatusList() {
			return Object.keys(this.statusFilter).filter(key => this.statusFilter[key] === true)
		},
		async onStatusFilterChanged() {
			// 筛选变了，之前那一页的页码就没意义了
			this.page = 1
			await this.loadCurrentList()
		},
		async loadCurrentList(isManual = false) {
			if (this.currentViewSwitcher === 'website') {
				await this.getAllWebsiteChats()
			} else if (this.currentViewSwitcher === 'airport') {
				await this.getAllAirportTickets()
			} else {
				await this.getAllVpnTopics(isManual)
			}
		},
		async onSearchClicked() {
			this.page = 1
			await this.loadCurrentList()
		},
		async onResetSearchClicked() {
			if (!this.searchKeyword) {
				return
			}
			this.searchKeyword = ''
			this.page = 1
			await this.loadCurrentList()
		},
		async checkLogin() {
			showLoading()
			const isVerified = await verifyFp()
			hideLoading()
			return isVerified
		},
		async getAllVpnTopics(isManual = false) {
			showLoading()
			const result = await postRequestAsync('admin/cs/getVpnAllTopics', {
				page: this.page,
				keyword: this.searchKeyword.trim(),
				statusList: this.getStatusList()
			})
			hideLoading()
			if (result?.code === 200 && result?.msg?.list) {
				this.vpnTopicList = result?.msg?.list
				this.totalCount = result?.msg?.totalCount
				if (isManual === true) {
					this.$message.success('刷新成功')
				}
			}
		},
		async getAllAirportTickets() {
			showLoading()
			const result = await postRequestAsync('admin/cs/getAirportTickets', {
				page: this.page,
				keyword: this.searchKeyword.trim(),
				statusList: this.getStatusList()
			})
			hideLoading()
			if (result?.code === 200 && result?.msg?.list) {
				this.airportTicketList = result?.msg?.list
				this.totalCount = result?.msg?.totalCount
			}
		},
		async getAllWebsiteChats() {
			showLoading()
			const result = await postRequestAsync('admin/cs/getAllWebsiteChats', {
				page: this.page,
				keyword: this.searchKeyword.trim(),
				statusList: this.getStatusList()
			})
			hideLoading()
			if (result?.code === 200 && result?.msg?.list) {
				this.websiteChatList = result?.msg?.list
				this.totalCount = result?.msg?.totalCount
			}
		},
		async refreshAllTopics() {
			await this.loadCurrentList()
		},
		async onTopicItemClicked(item) {
			showLoading()
			const result = await postRequestAsync('admin/cs/getTopicDetail', {
				topicId: item.feedbackTopicId,
				ticketId: item.ticketId
			})
			hideLoading()
			if (result.code === 200) {
				this.currentDisplayChat = result.msg
				this.currentDisplayTopic = item
				this.showMenuMobile = false
				if (result?.extra) {
					this.userReferByCode = result?.extra?.referCode || null
					this.userReferByEmail = result?.extra?.referByEmail || null
					this.userRegisterTime = result?.extra?.registerTime ? convertTimestampToTimeString(result?.extra?.registerTime) : null
					this.userPlanExpireTime = result?.extra?.planExpireTime ? convertTimestampToTimeString(result?.extra?.planExpireTime) : null
					this.usrePaymentRecords = result?.extra?.payments
				}
			} else {
				this.$message.error('获取反馈信息失败');
			}
		},
		getUserPaymentsDisplay() {
			if (Array.isArray(this.usrePaymentRecords) && this.usrePaymentRecords?.length > 0) {
				return `${this.usrePaymentRecords?.length}笔`
			}
			return '无'
		},
		async sendMsgReply() {
			if (this.currentDisplayTopic && this.currentDisplayTopic.ticketId) {
				await this.replyAirportTicket(this.currentDisplayTopic.ticketId)
				return
			}
			if (!this.currentDisplayTopic || !this.currentDisplayTopic.feedbackTopicId) {
				this.$message.error('请选择一个反馈');
				return
			}
			if (!this.toSendMsg) {
				this.$message.error('请输入信息');
				return
			}
			showLoading()
			const result = await postRequestAsync('customerServicePanel/sendTopicReply', {
				topicId: this.currentDisplayTopic.feedbackTopicId,
				msg: this.toSendMsg
			})
			hideLoading()
			if (result.code === 200) {
				this.$message.success('发送成功');
				this.toSendMsg = ''
				this.currentDisplayChat = this.msg
			} else {
				this.$message.error('发送失败');
			}
		},
		async replyAirportTicket(ticketId) {
			showLoading()
			const result = await postRequestAsync('airport/ticket/replyAirportTicket', {
				ticketId,
				replyMsg: this.toSendMsg
			})
			hideLoading()

			if (result.code === 200) {
				this.$message.success('发送成功');
				this.currentDisplayTopic = result.msg
			}
		},
		onShowMenuClicked() {
			console.log('onShowMenuClicked')
			this.showMenuMobile = true
		},
		onCloseMenuClicked() {
			this.showMenuMobile = false
		},
		async onVpnPageChanged(data) {

			this.page = data
			await this.getAllVpnTopics()

		},
		async onAirportPageChanged(data) {
			this.page = data
			await this.getAllAirportTickets()
		},
		async onWebsitePageChanged(data) {
			this.page = data
			await this.getAllWebsiteChats()
		},
		/**
		 * 禁言确认文案。说清时长和影响范围——这个按钮长得跟关闭工单挨着，
		 * 点错的代价是把人禁言一年。
		 */
		/**
		 * 删除确认文案。带上邮箱和描述开头，让人确认删的是哪一条——
		 * 这三个按钮挨在一起，删错了没法恢复。
		 */
		getDeleteConfirmText(item) {
			const desc = this.formatItemTitle(item?.userDescription || '')
			return `确认删除 ${item?.email || '该账号'} 的这条工单？「${desc}」及其全部对话将一并删除，不可恢复`
		},
		/**
		 * 删除工单。成功后直接从列表里摘掉，不重新拉整页——
		 * 重拉会把当前页码和筛选状态一起重置，客服正在往下翻的时候很烦。
		 */
		async onDeleteTopic(item) {
			if (!item?.feedbackTopicId || this.deletingTopicId) {
				return
			}
			this.deletingTopicId = item.feedbackTopicId
			try {
				const result = await postRequestAsync('admin/cs/deleteTopic', {
					topicId: item.feedbackTopicId
				})
				if (result?.code === 200) {
					this.vpnTopicList = this.vpnTopicList.filter(topic => topic.feedbackTopicId !== item.feedbackTopicId)
					this.$message.success('工单已删除')
				} else if (result?.code === 203) {
					// 已经被别的客服删掉了，列表里也不用留
					this.vpnTopicList = this.vpnTopicList.filter(topic => topic.feedbackTopicId !== item.feedbackTopicId)
					this.$message.warning('这条工单已经不存在了')
				} else {
					this.$message.error(`删除失败${result?.code ? `（${result.code}）` : ''}`)
				}
			} finally {
				this.deletingTopicId = null
			}
		},
		getMuteConfirmText(item) {
			return `确认禁言 ${item?.email || '该账号'} 一年？（仅客服渠道不能发言，不影响账号使用）`
		},
		/**
		 * 禁言这条工单的提交人。
		 *
		 * 成功后要把列表里同一个邮箱的工单全部标上——一个人往往提了好几条工单，
		 * 只改当前这条的话，同一个人的其它工单还显示"正常"，看着像没生效。
		 */
		async onMuteUser(item) {
			if (!item?.email || this.mutingEmail) {
				return
			}
			this.mutingEmail = item.email
			try {
				const result = await postRequestAsync('admin/user/muteUser', {
					email: item.email
				})
				if (result?.code === 200) {
					const banUntil = result?.msg?.banUntilTimeString
					for (const topic of this.vpnTopicList) {
						if (topic.email === item.email) {
							topic.isMuted = true
							topic.muteUntilTimeString = banUntil || ''
						}
					}
					this.$message.success(banUntil ? `已禁言，解禁时间 ${banUntil}` : '已禁言一年')
				} else if (result?.code === 303) {
					this.$message.error('用户表里找不到这个账号')
				} else {
					this.$message.error(`禁言失败${result?.code ? `（${result.code}）` : ''}`)
				}
			} finally {
				this.mutingEmail = null
			}
		},
		/**
		 * 用户状态标签的文字。禁用比禁言重，两个都中时只显示禁用——
		 * 完整信息在 title 里，不然一行塞两个标签会把邮箱挤到换行。
		 */
		getUserStateText(item) {
			if (item?.isBanned === true) {
				return '禁用'
			}
			if (item?.isMuted === true) {
				return '禁言'
			}
			return '正常'
		},
		getUserStateClass(item) {
			if (item?.isBanned === true) {
				return 'is-banned'
			}
			if (item?.isMuted === true) {
				return 'is-muted'
			}
			return 'is-normal'
		},
		/**
		 * 悬停提示。标签只显示更重的那个状态，被盖掉的那个和禁言到期时间放这里。
		 */
		getUserStateTitle(item) {
			const parts = []
			if (item?.isBanned === true) {
				parts.push('已加入黑名单')
			}
			if (item?.isMuted === true) {
				parts.push(item.muteUntilTimeString ? `禁言至 ${item.muteUntilTimeString}` : '已禁言')
			}
			return parts.join('；')
		},
		/**
		 * 复制邮箱。必须挡住冒泡：卡片本身绑了点击打开工单详情，
		 * 不挡的话每复制一次就弹一个详情框。
		 */
		async onCopyText(text, label, event) {
			event?.stopPropagation()
			if (!text) {
				return
			}
			const ok = await copyToClipboard(text)
			if (ok) {
				this.$message.success(`${label}已复制`)
			} else {
				this.$message.error('复制失败，请手动选中复制')
			}
		},
		/**
		 * 工单ID脱敏展示：只留头尾各 4 位，中间用 *** 代替。
		 * 太短的 ID（<= 8 位）再截就等于没有遮挡，原样返回。
		 */
		maskTicketId(id) {
			const text = String(id ?? '')
			if (text.length <= 8) {
				return text
			}
			return `${text.slice(0, 4)}***${text.slice(-4)}`
		},
		formatItemTitle(text) {
			if (!text) {
				return ''
			}
			if (text.length <= 10) {
				return text
			}
			return `${text.slice(0, 10)}...`;
		},

		getTicketStatusStyle(item) {
			if (item.topicState === '已回复') {
				return {
					'color': 'green'
				}
			}
			if (item.topicState === '等待回复') {
				return {
					'color': 'red'
				}
			}

		},
		getAirportTicketStatusStyle(item) {
			if (item.ticketStatus === 'replied') {
				return {
					'color': 'green'
				}
			}
			if (item.ticketStatus === 'wait_for_reply') {
				return {
					'color': 'red'
				}
			}

		},
		getWebsiteChatStatusStyle(item) {
			if (item.isReply === true) {
				return {
					'color': 'green'
				}
			}

			return {
				'color': 'red'
			}

		},
		getAirportTicketStatusText(item) {
			if (item.ticketStatus === 'replied') {
				return '已回复'
			}
			if (item.ticketStatus === 'wait_for_reply') {
				return '等待回复'
			}

		},
		getWebsiteChatStatusText(item) {
			if (item.isReply === true) {
				return '已回复'
			}

			return '等待回复'

		},
		onViewSwitcherClicked(viewType) {

			this.currentViewSwitcher = viewType
			this.page = 1;
			this.searchKeyword = ''
			this.loadCurrentList()
		},
		onItemClick(item) {
			if (this.currentViewSwitcher === 'vpn') {

				this.showTopicDetail = true
			} else if (this.currentViewSwitcher === 'website') {
				this.showWebsiteChatModal = true
			} else {
				this.showAirportTicketDetail = true

			}
			this.selectedItem = item
		},
		onTopicDetailClose() {
			this.showTopicDetail = false
		},
		onAirportTicketDetailClose() {
			this.showAirportTicketDetail = false
		},
		onWebsiteChatModalClose() {
			this.showWebsiteChatModal = false
		},
		async onWebsiteMsgSent() {
			await this.getAllWebsiteChats()
		},
		onConfirmModalCancel() {
			this.showConfirmModal = false
		},
		async onConfirmModalConfirm() {
			this.showConfirmModal = false
			if (this.confirmModalType === 'CLOSE_TICKET') {
				await this.doCloseTicket()
			}
		},
		async doCloseTicket() {
			showLoading()
			const result = await postRequestAsync('admin/cs/closeVpnTicket', {
				ticketId: this.selectedItem?.feedbackTopicId
			})
			hideLoading()

			if (result.code === 200) {
				this.$message.success('发送成功');
				await this.getAllVpnTopics()
			}

		},
		onCloseTicket(item, event) {
			event.stopPropagation()
			this.confirmMsg = '确认关闭工单？'
			this.showConfirmModal = true
			this.confirmModalType = 'CLOSE_TICKET'
			this.selectedItem = item
		}
	}
}
</script>

<style scoped>
.customer-service-page-container {
	min-height: 100vh;
	position: relative;
	background-color: #191123;
	overflow-x: hidden;
	width: 100vw;
	padding: 1em 0;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
}

/* 分页 / 搜索框 / 搜索按钮统一对齐 .cs-view-switch-btn（类目一、类目二）：
   同为 font-size 1.2em，高度 = 行高 1.2em + 上下各 0.2em 内边距 + 1px 边框 */
.cs-main-container :deep(.ant-pagination) {
	font-size: 1.2em;
	padding: 0.8em 0;
}

.cs-main-container :deep(.ant-pagination-simple .ant-pagination-prev),
.cs-main-container :deep(.ant-pagination-simple .ant-pagination-next),
.cs-main-container :deep(.ant-pagination-simple .ant-pagination-simple-pager) {
	height: calc(1.6em + 2px);
	line-height: calc(1.6em + 2px);
	min-width: calc(1.6em + 2px);
	margin-inline-end: 0.4em;
}

.cs-main-container :deep(.ant-pagination-simple .ant-pagination-item-link) {
	display: flex;
	align-items: center;
	justify-content: center;
	height: calc(1.6em + 2px);
	min-width: calc(1.6em + 2px);
	border-radius: 0.2em;
	font-size: 1em;
}

.cs-main-container :deep(.ant-pagination-simple .ant-pagination-simple-pager input) {
	height: calc(1.6em + 2px);
	/* 页码框不画边框，只留数字；宽度收窄到刚好放下页码。
	   App.vue 里有全局的 .ant-pagination.ant-pagination-simple input {border: 1px ... !important}，
	   不加 !important 盖不掉 */
	border: none !important;
	box-shadow: none;
	background-color: transparent;
	min-width: 2em;
	border-radius: 0.2em;
	font-size: 1em;
	line-height: 1.2em;
	text-align: center;
	/* App.vue 里有全局的 input {padding: 0 !important}，不加 !important 撑不开 */
	padding: 0 0.2em !important;
	margin-right: 0.4em;
}

/* 单独占一行放在分页下面。左右内边距对齐 btn-container / list-container */
.status-filter-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.8em;
	width: 100%;
	box-sizing: border-box;
	padding: 0 1em;
	margin-bottom: 1em;
}

/* antd 的复选框默认是浅色主题下的深字，放在深色面板上几乎看不见 */
.status-filter-container :deep(.ant-checkbox-wrapper) {
	color: #E6D5B8;
	font-size: 1em;
	/* 默认给相邻的 wrapper 加了 margin-left，会让 gap 的间距不均 */
	margin: 0;
	white-space: nowrap;
}

@media only screen and (max-width: 900px) {
	.status-filter-container {
		gap: 0.5em;
	}

	.cs-search-container {
		padding: 0.8em 1.2em 0 1.2em;
		gap: 0.5em;
	}

	.cs-search-btn {
		padding: 0.2em 0.7em;
	}
}

.cs-search-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 100%;
	box-sizing: border-box;
	padding: 0.8em 1em 0 1em;
	gap: 0.6em;
}

.cs-search-input {
	flex: 1;
	min-width: 0;
	max-width: 30em;
	color: #E6D5B8;
	background-color: transparent;
	border: 1px solid rgba(230, 213, 184, 0.6);
	border-radius: 0.2em;
	/* App.vue 里有全局的 input {padding: 0 !important}，这里必须同样用 !important 才能撑开输入框 */
	padding: 0.2em 0.8em !important;
	font-size: 1.2em;
	line-height: 1.2em;
	outline: none;
}

.cs-search-input:focus {
	border-color: #FF8900;
}

.cs-search-input::placeholder {
	color: rgba(230, 213, 184, 0.4);
}

.cs-search-btn {
	font-size: 1.2em;
	line-height: 1.2em;
	padding: 0.2em 1em;
	border-radius: 0.2em;
	white-space: nowrap;
}

.item-container:hover {
	transform: scale(1.01);
}

.tab-btn-container {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.item-title-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
}
/* 标题右侧的操作区：禁言按钮 + 关闭图标 */
.item-title-actions {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5em;
	flex: 0 0 auto;
}

/* 三个按钮同规格，只有颜色区分：都用描边不用实心——它们挨在一起，
   做得太抢眼容易点错，而三个操作的代价都不小（删除 / 禁言一年 / 关掉工单） */
.ticket-delete-btn,
.ticket-mute-btn,
.ticket-close-btn {
	border: 1px solid currentColor;
	border-radius: 0.3em;
	font-size: 0.8em;
	padding: 0.1em 0.6em;
	cursor: pointer;
	white-space: nowrap;
}

.ticket-mute-btn {
	color: #FF8900;
}

.ticket-close-btn {
	color: #ff6b6b;
}

/* 删除用灰色：它是三个里最不常用、后果最重的，不该比禁言和关闭更显眼 */
.ticket-delete-btn {
	color: rgba(230, 213, 184, 0.6);
}

.ticket-mute-btn.is-updating,
.ticket-delete-btn.is-updating {
	opacity: 0.5;
	pointer-events: none;
}

/* 邮箱那一行改成横排：邮箱 + 复制 + 状态标签。
   邮箱长短不一，min-width:0 让它能正常收缩，不然会把右边的标签挤出卡片 */
.item-email-line {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.4em;
	min-width: 0;
}

.item-email-text {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
}

.copy-text-btn {
	width: 1em;
	height: 1em;
	flex: 0 0 auto;
	cursor: pointer;
	opacity: 0.7;
}

.copy-text-btn:hover {
	opacity: 1;
}

/* 状态标签跟用户页保持同一套配色：红=禁用、橙=禁言、绿=正常，
   换个页面就换个颜色的话，同一个状态要重新认一遍 */
.user-state-tag {
	flex: 0 0 auto;
	font-size: 0.85em;
	padding: 0.1em 0.5em;
	border-radius: 0.3em;
	border: 1px solid currentColor;
	white-space: nowrap;
}

.user-state-tag.is-banned {
	color: #ff6b6b;
}

.user-state-tag.is-muted {
	color: #FF8900;
}

.user-state-tag.is-normal {
	color: #52c41a;
}
</style>